import React from 'react';

const DefaultLayoutsTabContext = React.createContext('emails');

export default DefaultLayoutsTabContext;
